function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.188 0C2.74 0 0 2.79 0 6.3 0 10.98 6.188 18 6.188 18s6.187-7.02 6.187-11.7c0-3.51-2.74-6.3-6.188-6.3zm0 8.55c-1.238 0-2.21-.99-2.21-2.25s.972-2.25 2.21-2.25c1.237 0 2.21.99 2.21 2.25s-.973 2.25-2.21 2.25z",
  fill: "#FFF",
  fillRule: "evenodd"
});

function SvgIconLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYuMTg4IDBDMi43NCAwIDAgMi43OSAwIDYuMyAwIDEwLjk4IDYuMTg4IDE4IDYuMTg4IDE4czYuMTg3LTcuMDIgNi4xODctMTEuN2MwLTMuNTEtMi43NC02LjMtNi4xODgtNi4zem0wIDguNTVjLTEuMjM4IDAtMi4yMS0uOTktMi4yMS0yLjI1cy45NzItMi4yNSAyLjIxLTIuMjVjMS4yMzcgMCAyLjIxLjk5IDIuMjEgMi4yNXMtLjk3MyAyLjI1LTIuMjEgMi4yNXoiIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
export { SvgIconLocation as ReactComponent };